import { factory } from "../../../../utils/apiThunkFactory";

export const getGlobalLivekitToken = factory.post('globalLivekit/getToken', '/api/token/global');